module.exports = __webpack_public_path__ + "img/mo1.2bd8bcc8.png";